import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { GeneralRouteV2Id } from 'routes/routesConfigV2';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import AlliedInitiateProposalPageStore, {
  AlliedInitiateProposalPageStoreContext,
  useAlliedInitiateProposalPageStore,
} from 'store/pages/initiate-quote/allied/pageStore';
import { useParams } from 'react-router-dom';
import AlliedInitiateProposalForm from 'components/initiate-quote/Allied';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate: { isInitialDataLoading, groupInfoDelegate, isFlowDataLoading },
    isActionLoading,
    canCompleteStep,
    proposalFormDelegate,
    domainParams: { groupId },
    getInitialData,
    saveProposal,
  } = useAlliedInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  const moreInfoBlob = groupInfoDelegate.moreInfoBlobInput
    ? buildGroupContextMoreInfoBlobProps(groupInfoDelegate.moreInfoBlobInput)
    : undefined;

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ groupId }}
      pageId={GeneralRouteV2Id.INITIATE_PROPOSAL}
      pageHeader={{ subtitleMaxWidth: '46rem' }}
      isInitialLoading={isInitialDataLoading}
      isInfoSectionLoading={isFlowDataLoading}
      isActionLoading={isActionLoading}
      moreInfoBlob={moreInfoBlob}
      pageFooter={{
        onComplete: saveProposal,
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <AlliedInitiateProposalForm proposalFormDelegate={proposalFormDelegate} />
    </PageInFlowNoSidebarLayout>
  );
});

const AlliedInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new AlliedInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <AlliedInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AlliedInitiateProposalPageStoreContext.Provider>
  );
};

export default AlliedInitiateProposalPage;
